import { AxiosError } from 'axios'
import { t } from 'i18next'
import { AxiosErrorType } from '~/shared/api'

export const mapMessageErrors = (e: AxiosErrorType) => {
  const errorMessage = e.response?.data?.errors
    ?.map((error) => error?.detail)
    .join(', ')
  return errorMessage || t('alert.server error')
}

export const mapMessageBlobErrors = async (e: AxiosError<Blob>) => {
  const errorBlob = e?.response?.data as Blob
  const jsonApi = await JSON.parse(await errorBlob?.text())

  const errorMessage = jsonApi?.errors
    ?.map((error: { detail: string }) => error?.detail)
    .join(', ')

  return errorMessage || t('alert.file receipt error')
}

export const mapErrorBlobToErrorType = async (e: AxiosError<Blob>) => {
  const errorBlob = e?.response?.data as Blob

  return {
    response: {
      data: {
        errors: JSON.parse(await errorBlob.text())?.errors,
      },
    },
  }
}
